import $ from 'jquery';
import Websockets from 'lib/websockets';
import config from 'lib/config';

const W = window;
const $W = $(W);
const $D = $(document);

let sidekick;
let timeout;
let promise;
let count = 0;

const COMMAND_SIDEKICK = `
  mutation commandSidekick($input: SidekickCommandInput!) {
    result: commandSidekick(input: $input) {
      data
    }
  }
`;

const sendCommand = async input => {
  if (input.id === undefined) input.id = 0;

  return $.GraphQL.runQuery(COMMAND_SIDEKICK, {
    operationName: 'commandSidekick',
    variables: {
      input,
    },
  });
};

$.hasSidekick = () => sidekick;

$.onAuth(async ({ authenticated, website, user }) => {
  if (authenticated && $.hasPerms('sidekick')) {
    const $body = $('body');
    const $btn = $('.btn-sidekick');
    const $popover = $('#sidekicks-popover');

    const sendKeepalive = async () => {
      if (sidekick && Websockets.isConnected()) {
        console.log('📱 SIDEKICK:KEEPALIVE');

        await sendCommand({
          id: sidekick.id,
          type: 'capture',
          payload: {
            count: ++count,
          },
        });
      }

      timeout = setTimeout(sendKeepalive, config.sidekick.user.keepalive * 1000);
    };

    $btn
      .on('show.bs.popover', async evt => {
        const loaded = $btn.data('loaded');

        if (loaded !== true) {
          evt.preventDefault();

          const { result } = await sendCommand({
            type: 'list',
          });

          const available = result.data.filter(s => !s.user || s.user.id !== user.id);
          const current = sidekick && sidekick.id ? result.data.find(s => s.id === sidekick.id) : null;

          $popover.render('sidekicks_popover', current, available);
          $btn.data('loaded', true).popover('show');
        }
      })

      .on('shown.bs.popover', () => {
        $btn.data('loaded', false);
      });

    $popover
      .on('click', '.btn-capture', async evt => {
        const $obj = $(evt.target).closest('.list-group-item');
        const id = $obj.data('id');
        const user_id = $obj.data('user-id');

        if (user_id && user_id !== user.id) {
          const result = await $.confirm('The chosen sidekick is already being used by another user. Are you sure you would like to continue?', 'Connect to Sidekick');
          if (!result) return;
        }

        $btn.popover('hide');
        count = 0;

        await sendCommand({
          id,
          type: 'capture',
          payload: {
            count: ++count,
          },
        });
      })

      .on('click', '.btn-release', async evt => {
        $btn.popover('hide');

        await sendCommand({
          id: sidekick.id,
          type: 'release',
        });
      });

    $W.on('websocket:opened', async () => {
      let id = $.globalStorage.get('sidekick');

      if (!id) $btn.find('.badge').removeClass('badge-success').addClass('badge-danger');
      else
        await sendCommand({
          id,
          type: 'capture',
          payload: {
            count: ++count,
          },
        });

      sendKeepalive();
    });

    $W.on('websocket:closed', async () => {
      clearTimeout(timeout);
      $body.removeClass('use-sidekick');
      $btn.find('.badge').removeClass('badge-success').addClass('badge-danger');
      $W.trigger('sidekick:change', [false]);
    });

    $.subscribe({ type: 'isolated', name: `sidekick:user:${user.id}` }, (channel, payload) => {
      const { type, id, name } = payload;

      switch (type) {
        case 'released': {
          if (sidekick) {
            console.groupCollapsed('📱 SIDEKICK:RELEASED');
            console.log('ID', sidekick.id);
            console.log('NAME', sidekick.name);
            console.groupEnd();
          }

          if (promise) promise.resolve();

          sidekick = null;
          $.globalStorage.remove('sidekick');
          $body.removeClass('use-sidekick');
          $btn.find('.badge').removeClass('badge-success').addClass('badge-danger');
          $W.trigger('sidekick:change', [false]);
          break;
        }

        case 'captured': {
          if (!sidekick || sidekick.id !== id) {
            console.groupCollapsed('📱 SIDEKICK:CAPTURED');
            console.log('ID', id);
            console.log('NAME', name);
            console.groupEnd();
          }

          sidekick = { id, name };
          $.globalStorage.set('sidekick', sidekick.id);
          $body.addClass('use-sidekick');
          $btn.find('.badge').removeClass('badge-danger').addClass('badge-success');
          $W.trigger('sidekick:change', [true]);
          break;
        }

        case 'result': {
          if (!promise) return;

          if (payload.error) promise.reject(payload.error);
          else promise.resolve(payload.result);

          break;
        }

        case 'cancel': {
          if (!promise) return;

          promise.resolve();

          break;
        }
      }
    });

    $D.on('click', '.sidekick .btn-cancel', async evt => {
      if (!promise) return;

      await sendCommand({
        type: 'cancel',
        id: sidekick.id,
      });

      promise.resolve(null);
    });

    $D.on('click', '[data-sidekick]', async evt => {
      if (!sidekick) return;

      const $obj = $(evt.target).closest('[data-sidekick]');
      const path = $obj.data('path');
      const params = $obj.data('params');

      try {
        const result = await $.sidekick(path, params);

        $obj.trigger('sidekick:result', result);
      } catch (err) {
        $.toastr({ type: 'error', message: err });
      }
    });

    $.sidekick = async (path, params) => {
      return new Promise(async (resolve, reject) => {
        promise = { resolve, reject };

        const $sidekick = $('<div class="sidekick fade"><h1>Waiting for<br/>customer</h1><a class="btn btn-warning btn-cancel">Cancel</a></div>').appendTo($body);

        await sendCommand({
          id: sidekick.id,
          type: 'navigate',
          payload: {
            path,
            params,
          },
        });

        setTimeout(() => {
          $sidekick.addClass('show');
        }, 0);
      }).finally(() => {
        promise = null;
        $body.find('.sidekick').remove();
      });
    };
  }
});
